<template lang="pug">
  slick(
    :class='"default-slider"'
    :options='options'
    @init='emmiter'
    ref='slick'
    @beforeChange='slickSlideFound'
  )
    slot(name="slide")
</template>

<script>
import Slick from 'vue-slick'

export default {
  components: {
    Slick,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    video: {
      default: false,
    },
  },
  data() {
    return {
      clickCount: 0,
    }
  },
  methods: {
    emmiter(event, slick) {
      this.$emit('init', slick)
    },
    slickSlideFound() {
      this.clickCount++
      this.$emit('updateParent', {
        slideNextPlay: this.clickCount,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/Forms/UiSlider.vue